import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, CircularProgress, Chip, TextField, Divider } from '@mui/material';
import axios from 'axios';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {getPharmaorderInfoByStatusAPI} from '../PharmaorderAPI';
import { setPharmaorderList } from 'store/slice/PharmaSlice';

import PharmaorderDashboard from '../PharmaorderDashboard';
import { callGetAPI } from 'api/ApiUtils';
import { transformDateValue } from 'core/js/FormUtils';
import FieldView2 from 'core/components/layout/FieldView2';
import {resumeProductAPI} from 'api/OmsOrdermgmtWebServices';
import { setProductViewproductModal, setSelectedProductId, setSelectedPharmaorderId } from 'store/slice/PharmaSlice';
import ViewproductActionModal from '../../product/action/viewproduct/ViewproductActionModal';
import { archiveToCurrentAPI } from 'api/OmsOrdermgmtWebServices';

export default function PharmaorderPageCancelledAndHold({label, typeId, refreshKey}) {
    const dispatch = useDispatch();
    //const { pharmaorderList } = useSelector((state) => state.pharmaslice);
    const { userprofileInfo } = useSelector((state) => state.headerslice);
    const [productDetails, setProductDetails] = useState({});
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [pharmaorderListLocal, setPharmaorderListLocal] = useState([]);
    const {rolename} = useSelector((state) => state.headerslice.userprofileInfo);
    
    // Filter states
    const [filterOrderId, setFilterOrderId] = useState('');
    const [filterPartyName, setFilterPartyName] = useState('');
    const [filterBrandName, setFilterBrandName] = useState('');
    const [filterTitle, setFilterTitle] = useState('');
    
    useEffect(() => {
        setLoadingProducts(true); // Show loader before API call
        callGetAPI("https://api.mypharmafactory.com/extn/products/statusid/" + typeId,
            () => {},
            (apiResponse) => { 
                setPharmaorderListLocal(apiResponse);
                setLoadingProducts(false); // Hide loader after success
            },
            (error) => {
                console.error('Error fetching orders with products:', error);
                setLoadingProducts(false); // Hide loader after error
            }
        );
    }, [typeId, refreshKey]);


    // Filter the orders based on search criteria
    const filteredOrders = (pharmaorderListLocal || []).filter(prod => {
        const matchesOrderId = filterOrderId === '' || (prod.orderid && prod.orderid.toString().toLowerCase().includes(filterOrderId.toLowerCase()));
        const matchesPartyName = filterPartyName === '' || (prod.partyname && prod.partyname.toLowerCase().includes(filterPartyName.toLowerCase()));
        const matchesBrandName = filterBrandName === '' || (prod.brandname && prod.brandname.toLowerCase().includes(filterBrandName.toLowerCase()));
        const matchesTitle = filterTitle === '' || (prod.title && prod.title.toLowerCase().includes(filterTitle.toLowerCase()));

        return matchesOrderId && matchesPartyName && matchesBrandName && matchesTitle;
    });

    // Popup state
    const [resumeDialogOpen, setResumeDialogOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [resumeLoading, setResumeLoading] = useState(false);
    const [resumeError, setResumeError] = useState('');

    // Handler for Resume button click
    const handleResumeClick = (prod) => {
        setSelectedProduct(prod);
        setResumeDialogOpen(true);
        setResumeError('');
    };

    // Handler for confirming resume
    const handleResumeConfirm = () => {
        if (!selectedProduct) return;
        setResumeLoading(true);
        setResumeError('');
        resumeProductAPI(
            { productId: selectedProduct.id },
            (response) => {
                setResumeLoading(false);
                setResumeDialogOpen(false);
                setLoadingProducts(true); // Show loader before refresh
                callGetAPI("https://api.mypharmafactory.com/extn/products/statusid/" + typeId,
                    () => {},
                    (list) => { 
                        setPharmaorderListLocal(list || []);
                        setLoadingProducts(false); // Hide loader after refresh
                    },
                    (error) => {
                        console.error('Error fetching orders with products:', error);
                        setLoadingProducts(false); // Hide loader after error
                    }
                );
            },
            (error) => {
                setResumeLoading(false);
                setResumeError('Failed to resume product. Please try again.');
            }
        );
    };

    // Handler for closing dialog
    const handleResumeDialogClose = () => {
        setResumeDialogOpen(false);
        setSelectedProduct(null);
        setResumeError('');
    };
    const viewProductDetails = (productObj) => {
        
        dispatch(setSelectedPharmaorderId(productObj.orderid));
        dispatch(setSelectedProductId(productObj.id));
        dispatch(setProductViewproductModal(true));
        
    };

    return (
        <Grid container direction="column" sx={{ width: '100%', p: 1 }}>
            <Grid item xs={12}>
                <Box sx={{ mb: 1 }}>
                    <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        {label}
                    </Typography>
                </Box>
                
                {/* Filter Section */}
                <Box sx={{ 
                    mb: 1, 
                    p: 1, 
                    backgroundColor: 'grey.50', 
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'grey.200'
                }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                        Filter Orders
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Order ID"
                                placeholder="Search by Order ID"
                                value={filterOrderId}
                                onChange={(e) => setFilterOrderId(e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Party Name"
                                placeholder="Search by Party Name"
                                value={filterPartyName}
                                onChange={(e) => setFilterPartyName(e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Brand Name"
                                placeholder="Search by Brand Name"
                                value={filterBrandName}
                                onChange={(e) => setFilterBrandName(e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Composition"
                                placeholder="Search by Composition"
                                value={filterTitle}
                                onChange={(e) => setFilterTitle(e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                
                {loadingProducts ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                        <CircularProgress size={48} />
                        <Typography variant="h6" sx={{ ml: 2 }}>
                            Loading orders...
                        </Typography>
                    </Box>
                ) : (
                    <TableContainer component={Paper} sx={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                        <Table sx={{ minWidth: 650 }} aria-label="pharma orders table">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: 'primary.lighter' }}>
                                    <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem', width: '100%' }}>Product Info</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredOrders && filteredOrders.length > 0 ? (
                                    filteredOrders.map((prod, index) => {
                                        return (
                                            <TableRow 
                                                key={prod.id || index}
                                                sx={{ 
                                                    backgroundColor: 'transparent',
                                                    '&:hover': { 
                                                        backgroundColor: 'secondary.100'
                                                    }
                                                }}
                                            >
                                                <TableCell sx={{  verticalAlign: 'top' }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column'}}>
                                                                    <Box 
                                                                        sx={{ 
                                                                            display: 'flex', 
                                                                            alignItems: 'flex-start',
                                                                            gap: 2 
                                                                        }}
                                                                    >
                                                                        {/* Product Info Box */}
                                                                        <Box sx={{ 
                                                                            p: 1, 
                                                                            backgroundColor: 'grey.50', 
                                                                            borderRadius: 1, 
                                                                            width: '50%' 
                                                                        }}>
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                <Box>
                                                                                    <Typography variant="body2" sx={{color: 'text.secondary', fontSize: '0.75rem'}}>
                                                                                            Order ID #{prod.orderid}
                                                                                    </Typography>
                                                                                     <Typography variant="h6" sx={{color: 'primary.main'}}>
                                                                                            {prod.brandname}
                                                                                    </Typography>
                                                                                   
                                                                                    <Typography variant="body2" sx={{color: 'text.secondary', fontSize: '0.75rem'}}>
                                                                                            {prod.partyname}
                                                                                    </Typography>
                                                                                </Box>
                                                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                                                                    <Button
                                                                                        variant="text"
                                                                                        size="small"
                                                                                        startIcon={<VisibilityIcon />}
                                                                                        sx={{ ml: 1, fontWeight: 600, color: 'primary.main', textTransform: 'none' }}
                                                                                        onClick={() => viewProductDetails(prod)}
                                                                                    >
                                                                                        View Product
                                                                                    </Button>
                                                                                    {userprofileInfo.rolename === "PHARMA_OMS_ADMIN" && (
                                                                                    <Button
                                                                                        variant="outlined"
                                                                                        size="small"
                                                                                        sx={{ mt: 1, ml: 1, fontWeight: 600, color: 'primary.main', borderColor: 'primary.main', textTransform: 'none' }}
                                                                                        onClick={() => {
                                                                                            archiveToCurrentAPI(
                                                                                                { productId: prod.id },
                                                                                                (response) => {
                                                                                                    setPharmaorderListLocal(prevList => prevList.filter(p => p.id !== prod.id));
                                                                                                },
                                                                                                (error) => {
                                                                                                    // Optionally show error
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        Move To Current
                                                                                    </Button>
                                                                                    )}
                                                                                </Box>
                                                                            </Box>
                                                                            <Typography variant="body2" sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                                                                                {prod.formname}
                                                                            </Typography>
                                                                            <Typography variant="h6" sx={{ mt: 1 }}>
                                                                                {prod.title}
                                                                            </Typography>
                                                                        </Box>
                                                                        {/* Product Status Box */}
                                                                        <Box
                                                                            sx={{
                                                                                display: 'inline-block',
                                                                                backgroundColor: 'secondary.100',
                                                                                borderRadius: 1,
                                                                                px: 1.5,
                                                                                py: 0.5,
                                                                                width: '50%',
                                                                                minWidth: 90,
                                                                                transition: 'background 0.2s',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'white'
                                                                                },
                                                                                display: 'flex',
                                                                                flexDirection: 'column',
                                                                                alignItems: 'flex-start',
                                                                                justifyContent: 'flex-start'
                                                                            }}
                                                                        >
                                                                            <FieldView2 label="Reason" value={prod.reason} sx={{  }} />
                                                                            <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between',  }}>
                                                                                <FieldView2 label={prod.overallstatusid==9?"On Hold Date":"Cancellation Date"} value={transformDateValue(prod.reasondate)} />
                                                                                {prod.overallstatusid === 9 && (rolename ==="PHARMA_OMS_ADMIN" || rolename === "PHARMA_OMS_MANAGER") && (
                                                                                    <button
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            background: '#1976d2',
                                                                                            color: '#fff',
                                                                                            border: 'none',
                                                                                            borderRadius: 4,
                                                                                            padding: '4px 12px',
                                                                                            cursor: 'pointer',
                                                                                            fontWeight: 600,
                                                                                            fontSize: '0.85rem'
                                                                                        }}
                                                                                        onClick={() => handleResumeClick(prod)}
                                                                                    >
                                                                                        <PlayArrowIcon sx={{ fontSize: 18, mr: 0.5 }} />
                                                                                        Resume
                                                                                    </button>
                                                                                )}
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                { pharmaorderListLocal && pharmaorderListLocal.length === 0 
                                                    ? `No ${typeId === 'CANCELLED' ? 'cancelled' : 'on hold'} orders found`
                                                    : 'No orders match the current filters'
                                                }
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Grid>

            {/* Resume Product Confirmation Dialog */}
            <Dialog open={resumeDialogOpen} onClose={handleResumeDialogClose} maxWidth="xs" fullWidth>
                <DialogTitle>Resume Product</DialogTitle>
                <DialogContent>
                    {selectedProduct && (
                        <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
                            <FieldView2 label="Party" value={selectedProduct.partyname} />
                            <FieldView2 label="Brand" value={selectedProduct.brandname} />
                        </Box>
                    )}
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        Are you sure you want to resume this product?
                    </Typography>
                    {resumeError && (
                        <Typography color="error" sx={{ mt: 2 }}>
                            {resumeError}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleResumeDialogClose} color="secondary" disabled={resumeLoading}>
                        Cancel
                    </Button>
                    <Button onClick={handleResumeConfirm} color="primary" variant="contained" disabled={resumeLoading}>
                        {resumeLoading ? <CircularProgress size={20} /> : "Confirm"}
                    </Button>
                </DialogActions>
            </Dialog>
            <ViewproductActionModal />
        </Grid>
    )
}
